var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "c-comments u-m-b5" },
    [
      _c("comment-box"),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm._l(_vm.comments, function (comment) {
            return _c("post-comments", {
              key: comment.comment_id,
              attrs: { comment: comment },
            })
          }),
          _vm._v(" "),
          this.$root.comments.length > 5 && !_vm.showAll
            ? _c(
                "div",
                {
                  staticClass: "u-align-center",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.moreComments.apply(null, arguments)
                    },
                  },
                },
                [_c("button", { staticClass: "c-btn3" }, [_vm._v("More")])]
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }